export interface Place {  
  name: string;
  id: Array<String>
  address: Address;
  latlng: string;
  tags: Array<string>;
  summary: string;
  index: Array<string>;
}

export interface Address {
  street: string;
  number: string;
  postCode: string;
  suburb: string;
  district: string;
  city: string;
}

export interface Filter {
  search: string;
  tags: Array<string>;
}

export class EmptyFilter implements Filter {
  search = '';
  tags = new Array<string>();
}
